import styled from 'styled-components';

export const Wrapper = styled.div`
  font-size: 14px;
  line-height: 21px;
`;

export const Title = styled.span`
  font-weight: 600;
`;

export const Value = styled.span`
  font-weight: 400;
`;
